import ENVIRONMENT_VARIABLES from './environmentVariables';
var application = ENVIRONMENT_VARIABLES.APPLICATION_TARGET;
export var isHri = application === 'hri';
export var isSga = application === 'sga';